// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file plataforma_hardware_gps_trackers.proto (package sextante.plataforma.hardware.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plataforma_hardware_gps_trackers.proto.
 */
export const file_plataforma_hardware_gps_trackers: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.hardware.v1.ListGpsTrackersRequest
 */
export type ListGpsTrackersRequest = Message<"sextante.plataforma.hardware.v1.ListGpsTrackersRequest"> & {
};

/**
 * Describes the message sextante.plataforma.hardware.v1.ListGpsTrackersRequest.
 * Use `create(ListGpsTrackersRequestSchema)` to create a new message.
 */
export const ListGpsTrackersRequestSchema: GenMessage<ListGpsTrackersRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 0);

/**
 * GPS trackers no eliminados.
 *
 * @generated from message sextante.plataforma.hardware.v1.ListGpsTrackersResponse
 */
export type ListGpsTrackersResponse = Message<"sextante.plataforma.hardware.v1.ListGpsTrackersResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.hardware.v1.GpsTrackerPlataformaItem items = 1;
   */
  items: GpsTrackerPlataformaItem[];
};

/**
 * Describes the message sextante.plataforma.hardware.v1.ListGpsTrackersResponse.
 * Use `create(ListGpsTrackersResponseSchema)` to create a new message.
 */
export const ListGpsTrackersResponseSchema: GenMessage<ListGpsTrackersResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 1);

/**
 * GPS tracker de RASTRO.
 *
 * @generated from message sextante.plataforma.hardware.v1.GpsTrackerPlataformaItem
 */
export type GpsTrackerPlataformaItem = Message<"sextante.plataforma.hardware.v1.GpsTrackerPlataformaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Numero de inventario del GPS en Sextante.
   *
   * @generated from field: int32 codigo_interno = 2;
   */
  codigoInterno: number;

  /**
   * 0 = nunca asignado a un cliente.
   *
   * @generated from field: int32 codigo_cliente = 3;
   */
  codigoCliente: number;

  /**
   * Ausente = no testeado.
   *
   * Unix ms
   *
   * @generated from field: optional int64 fecha_testeo = 4;
   */
  fechaTesteo?: bigint | undefined;

  /**
   * true si paso la prueba de funcionamiento.
   *
   * @generated from field: bool pasa_test = 5;
   */
  pasaTest: boolean;

  /**
   * Motivo por el que no paso la prueba.
   *
   * @generated from field: optional string nota_test = 6;
   */
  notaTest?: string | undefined;

  /**
   * Ausente = en oficina.
   *
   * @generated from field: optional string cliente_id = 7;
   */
  clienteId?: string | undefined;

  /**
   * @generated from field: optional string cliente_nombre = 8;
   */
  clienteNombre?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GpsTrackerPlataformaItem.
 * Use `create(GpsTrackerPlataformaItemSchema)` to create a new message.
 */
export const GpsTrackerPlataformaItemSchema: GenMessage<GpsTrackerPlataformaItem> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 2);

/**
 * Sin parametros.
 *
 * @generated from message sextante.plataforma.hardware.v1.GpsTrackerStatsRequest
 */
export type GpsTrackerStatsRequest = Message<"sextante.plataforma.hardware.v1.GpsTrackerStatsRequest"> & {
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GpsTrackerStatsRequest.
 * Use `create(GpsTrackerStatsRequestSchema)` to create a new message.
 */
export const GpsTrackerStatsRequestSchema: GenMessage<GpsTrackerStatsRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 3);

/**
 * Totales de GPS trackers para los KPI.
 *
 * @generated from message sextante.plataforma.hardware.v1.GpsTrackerStatsResponse
 */
export type GpsTrackerStatsResponse = Message<"sextante.plataforma.hardware.v1.GpsTrackerStatsResponse"> & {
  /**
   * @generated from field: int32 total = 1;
   */
  total: number;

  /**
   * @generated from field: int32 asignados_a_cliente = 2;
   */
  asignadosACliente: number;

  /**
   * @generated from field: int32 en_oficina = 3;
   */
  enOficina: number;

  /**
   * @generated from field: int32 no_pasan_test = 4;
   */
  noPasanTest: number;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GpsTrackerStatsResponse.
 * Use `create(GpsTrackerStatsResponseSchema)` to create a new message.
 */
export const GpsTrackerStatsResponseSchema: GenMessage<GpsTrackerStatsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 4);

/**
 * GPS a crear, o datos de prueba a editar.
 *
 * @generated from message sextante.plataforma.hardware.v1.GuardarGpsTrackerRequest
 */
export type GuardarGpsTrackerRequest = Message<"sextante.plataforma.hardware.v1.GuardarGpsTrackerRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * Unix ms
   *
   * @generated from field: optional int64 fecha_testeo = 2;
   */
  fechaTesteo?: bigint | undefined;

  /**
   * @generated from field: bool pasa_test = 3;
   */
  pasaTest: boolean;

  /**
   * Se ignora si pasa_test.
   *
   * @generated from field: optional string nota_test = 4;
   */
  notaTest?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GuardarGpsTrackerRequest.
 * Use `create(GuardarGpsTrackerRequestSchema)` to create a new message.
 */
export const GuardarGpsTrackerRequestSchema: GenMessage<GuardarGpsTrackerRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 5);

/**
 * GPS a asignar a un cliente o devolver a oficina.
 *
 * @generated from message sextante.plataforma.hardware.v1.AsignarGpsTrackerRequest
 */
export type AsignarGpsTrackerRequest = Message<"sextante.plataforma.hardware.v1.AsignarGpsTrackerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Ausente = devolver a oficina.
   *
   * @generated from field: optional string cliente_id = 2;
   */
  clienteId?: string | undefined;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.AsignarGpsTrackerRequest.
 * Use `create(AsignarGpsTrackerRequestSchema)` to create a new message.
 */
export const AsignarGpsTrackerRequestSchema: GenMessage<AsignarGpsTrackerRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 6);

/**
 * GPS sobre el que se actua.
 *
 * @generated from message sextante.plataforma.hardware.v1.GpsTrackerIdRequest
 */
export type GpsTrackerIdRequest = Message<"sextante.plataforma.hardware.v1.GpsTrackerIdRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GpsTrackerIdRequest.
 * Use `create(GpsTrackerIdRequestSchema)` to create a new message.
 */
export const GpsTrackerIdRequestSchema: GenMessage<GpsTrackerIdRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 7);

/**
 * Sin datos: que el rpc no falle ya indica que se hizo.
 *
 * @generated from message sextante.plataforma.hardware.v1.GpsTrackerAccionResponse
 */
export type GpsTrackerAccionResponse = Message<"sextante.plataforma.hardware.v1.GpsTrackerAccionResponse"> & {
};

/**
 * Describes the message sextante.plataforma.hardware.v1.GpsTrackerAccionResponse.
 * Use `create(GpsTrackerAccionResponseSchema)` to create a new message.
 */
export const GpsTrackerAccionResponseSchema: GenMessage<GpsTrackerAccionResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 8);

/**
 * GPS y dia de los envios a descargar. Un solo dia por pedido.
 *
 * @generated from message sextante.plataforma.hardware.v1.DescargarEnviosGpsRequest
 */
export type DescargarEnviosGpsRequest = Message<"sextante.plataforma.hardware.v1.DescargarEnviosGpsRequest"> & {
  /**
   * Numero de inventario del GPS: nombra su base de envios.
   *
   * @generated from field: int32 codigo_interno = 1;
   */
  codigoInterno: number;

  /**
   * Dia de llegada al servidor en hora de Colombia, aaaa-mm-dd.
   *
   * @generated from field: string fecha = 2;
   */
  fecha: string;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.DescargarEnviosGpsRequest.
 * Use `create(DescargarEnviosGpsRequestSchema)` to create a new message.
 */
export const DescargarEnviosGpsRequestSchema: GenMessage<DescargarEnviosGpsRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 9);

/**
 * Envios de un GPS en un dia, unidos en un solo texto.
 *
 * @generated from message sextante.plataforma.hardware.v1.DescargarEnviosGpsResponse
 */
export type DescargarEnviosGpsResponse = Message<"sextante.plataforma.hardware.v1.DescargarEnviosGpsResponse"> & {
  /**
   * El contenido de cada envio tal cual llego, uno detras de otro y cada uno terminado en salto de linea. Vacio si
   * ese dia no llego nada.
   *
   * @generated from field: string contenido = 1;
   */
  contenido: string;

  /**
   * Cuantos envios llegaron ese dia, incluidos los que llegaron vacios.
   *
   * @generated from field: int32 envios = 2;
   */
  envios: number;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.DescargarEnviosGpsResponse.
 * Use `create(DescargarEnviosGpsResponseSchema)` to create a new message.
 */
export const DescargarEnviosGpsResponseSchema: GenMessage<DescargarEnviosGpsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 10);

/**
 * GPS del que se listan los dias con envios.
 *
 * @generated from message sextante.plataforma.hardware.v1.ListarDiasEnviosGpsRequest
 */
export type ListarDiasEnviosGpsRequest = Message<"sextante.plataforma.hardware.v1.ListarDiasEnviosGpsRequest"> & {
  /**
   * Numero de inventario del GPS: nombra su base de envios.
   *
   * @generated from field: int32 codigo_interno = 1;
   */
  codigoInterno: number;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.ListarDiasEnviosGpsRequest.
 * Use `create(ListarDiasEnviosGpsRequestSchema)` to create a new message.
 */
export const ListarDiasEnviosGpsRequestSchema: GenMessage<ListarDiasEnviosGpsRequest> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 11);

/**
 * Dias con envios de un GPS, del mas reciente al mas viejo. Vacio si su base existe pero no tiene envios.
 *
 * @generated from message sextante.plataforma.hardware.v1.ListarDiasEnviosGpsResponse
 */
export type ListarDiasEnviosGpsResponse = Message<"sextante.plataforma.hardware.v1.ListarDiasEnviosGpsResponse"> & {
  /**
   * @generated from field: repeated sextante.plataforma.hardware.v1.DiaEnviosGps dias = 1;
   */
  dias: DiaEnviosGps[];
};

/**
 * Describes the message sextante.plataforma.hardware.v1.ListarDiasEnviosGpsResponse.
 * Use `create(ListarDiasEnviosGpsResponseSchema)` to create a new message.
 */
export const ListarDiasEnviosGpsResponseSchema: GenMessage<ListarDiasEnviosGpsResponse> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 12);

/**
 * Un dia con envios de un GPS.
 *
 * @generated from message sextante.plataforma.hardware.v1.DiaEnviosGps
 */
export type DiaEnviosGps = Message<"sextante.plataforma.hardware.v1.DiaEnviosGps"> & {
  /**
   * Dia de llegada al servidor en hora de Colombia, aaaa-mm-dd: el mismo que recibe DescargarEnvios.
   *
   * @generated from field: string fecha = 1;
   */
  fecha: string;

  /**
   * Cuantos envios llegaron ese dia, incluidos los que llegaron vacios.
   *
   * @generated from field: int32 envios = 2;
   */
  envios: number;
};

/**
 * Describes the message sextante.plataforma.hardware.v1.DiaEnviosGps.
 * Use `create(DiaEnviosGpsSchema)` to create a new message.
 */
export const DiaEnviosGpsSchema: GenMessage<DiaEnviosGps> = /*@__PURE__*/
  messageDesc(file_plataforma_hardware_gps_trackers, 13);

/**
 * Inventario de GPS trackers (RASTRO) de la app Plataforma (menu Hardware). Migracion a gRPC-Web con logica
 * propia (ver CLAUDE.md). Solo los campos que usa la web. Requiere sesion de Plataforma.
 *
 * @generated from service sextante.plataforma.hardware.v1.GpsTrackersPlataformaService
 */
export const GpsTrackersPlataformaService: GenService<{
  /**
   * Trackers no eliminados, con el cliente asignado.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.ListGpsTrackers
   */
  listGpsTrackers: {
    methodKind: "unary";
    input: typeof ListGpsTrackersRequestSchema;
    output: typeof ListGpsTrackersResponseSchema;
  },
  /**
   * Totales para los KPIs.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.GetStats
   */
  getStats: {
    methodKind: "unary";
    input: typeof GpsTrackerStatsRequestSchema;
    output: typeof GpsTrackerStatsResponseSchema;
  },
  /**
   * Alta (codigo interno de la secuencia, en oficina) o edicion de los datos de testeo.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarGpsTrackerRequestSchema;
    output: typeof GpsTrackerPlataformaItemSchema;
  },
  /**
   * Asigna a un cliente (con su codigo de cliente) o devuelve a oficina (cliente ausente).
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.Asignar
   */
  asignar: {
    methodKind: "unary";
    input: typeof AsignarGpsTrackerRequestSchema;
    output: typeof GpsTrackerPlataformaItemSchema;
  },
  /**
   * Baja logica. Idempotente.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof GpsTrackerIdRequestSchema;
    output: typeof GpsTrackerAccionResponseSchema;
  },
  /**
   * CSV de los envios que llegaron de un GPS en un dia (hora de Colombia), tal cual los mando el aparato y en orden
   * de llegada. Se leen de la base de envios del GPS (gps_tracker_{codigo_interno}). Lo usan el menu Hardware y la
   * pestana Dispositivos del cliente; un promotor solo descarga los GPS de los clientes de su cartera.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.DescargarEnvios
   */
  descargarEnvios: {
    methodKind: "unary";
    input: typeof DescargarEnviosGpsRequestSchema;
    output: typeof DescargarEnviosGpsResponseSchema;
  },
  /**
   * Dias (hora de Colombia) en que llegaron envios de un GPS, del mas reciente al mas viejo, con cuantos llegaron cada
   * dia. La ventana de descarga muestra solo esos dias para escoger uno. Mismas reglas que DescargarEnvios.
   *
   * @generated from rpc sextante.plataforma.hardware.v1.GpsTrackersPlataformaService.ListarDiasEnvios
   */
  listarDiasEnvios: {
    methodKind: "unary";
    input: typeof ListarDiasEnviosGpsRequestSchema;
    output: typeof ListarDiasEnviosGpsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_plataforma_hardware_gps_trackers, 0);

